import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-349fd234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ftl-order" }
const _hoisted_2 = { class: "container__block mt-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block__title" }, "Информация об опоздании на отгрузке", -1))
const _hoisted_4 = {
  key: 0,
  class: "no-data"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список пуст", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 2,
  class: "mt-2 flex justify-end items-center"
}
const _hoisted_11 = { class: "container__block mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block__title" }, "Информация об опоздании на приемке", -1))
const _hoisted_13 = {
  key: 0,
  class: "FTLOrderSenderAndStops__no-data"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Список пуст", -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "mt-2 flex justify-end items-center"
}
const _hoisted_20 = { class: "ftl-order__container" }
const _hoisted_21 = { class: "container__slot" }
const _hoisted_22 = { class: "container__statuses" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!
  const _component_ftl_on_the_way = _resolveComponent("ftl-on-the-way")!
  const _component_ftl_set_comment_modal = _resolveComponent("ftl-set-comment-modal")!
  const _component_ftl_declaration = _resolveComponent("ftl-declaration")!
  const _component_ftl_cross_border = _resolveComponent("ftl-cross-border")!
  const _component_enter_delivered_data = _resolveComponent("enter-delivered-data")!
  const _component_enter_completed_data = _resolveComponent("enter-completed-data")!
  const _component_upload_ftl_order_scan = _resolveComponent("upload-ftl-order-scan")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_upload_ftl_stock_scan = _resolveComponent("upload-ftl-stock-scan")!
  const _component_bids_form_ftl = _resolveComponent("bids-form-ftl")!
  const _component_ftl_order_state = _resolveComponent("ftl-order-state")!
  const _component_ftl_order_header = _resolveComponent("ftl-order-header")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_new_table = _resolveComponent("new-table")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_ftl_order_tabs = _resolveComponent("ftl-order-tabs")!
  const _component_ftl_order_general = _resolveComponent("ftl-order-general")!
  const _component_ftl_order_payment = _resolveComponent("ftl-order-payment")!
  const _component_ftl_order_sender_and_stops = _resolveComponent("ftl-order-sender-and-stops")!
  const _component_ftl_order_vehicle = _resolveComponent("ftl-order-vehicle")!
  const _component_ftl_order_files = _resolveComponent("ftl-order-files")!
  const _component_ftl_order_statuses = _resolveComponent("ftl-order-statuses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.comment_state.is_open)
      ? (_openBlock(), _createBlock(_component_new_modal, {
          key: 0,
          title: "Добавить комментарий",
          loading: _ctx.comment_state.is_loading,
          onSubmit: _ctx.setComment,
          onCancel: _ctx.toggleCancel
        }, {
          default: _withCtx(() => [
            _createVNode(_component_new_select, {
              value: _ctx.comment_state.commentId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment_state.commentId) = $event)),
              placeholder: "Выберите комментарий",
              options: _ctx.comment_state.list,
              loading: _ctx.comment_state.is_loading,
              failed: _ctx.comment_state.is_failed,
              disabled: _ctx.comment_state.is_loading,
              "is-invalid": _ctx.comment_form$.commentId.$error,
              "validation-errors": _ctx.comment_form$.commentId.$errors,
              "error-text": "При получении списка комментариев произошла ошибка",
              "search-without-refresh": ""
            }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_on_the_way)
      ? (_openBlock(), _createBlock(_component_ftl_on_the_way, {
          key: 1,
          "is-loading": _ctx.state.is_on_the_way_loading,
          "order-id": _ctx.$route.params.order_id,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "is-comment": Boolean(_ctx.state.ftlDelayOutbound.length),
          "state-id": _ctx.state.stateId,
          onSubmit: _ctx.onTheWaySubmit,
          onCancel: _ctx.onTheWayCancel
        }, null, 8, ["is-loading", "order-id", "ftl-type", "is-comment", "state-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_set_comment)
      ? (_openBlock(), _createBlock(_component_ftl_set_comment_modal, {
          key: 2,
          "is-loading": _ctx.state.is_set_comment_loading,
          "ftl-order": _ctx.state.ftlOrder,
          "state-id": _ctx.state.stateId,
          onSubmit: _ctx.onSetCommentNewSubmit,
          onCancel: _ctx.onSetCommentCancel
        }, null, 8, ["is-loading", "ftl-order", "state-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_export_declaration_issued)
      ? (_openBlock(), _createBlock(_component_ftl_declaration, {
          key: 3,
          "order-id": _ctx.$route.params.order_id,
          onSubmit: _ctx.onExportDeclarationIssuedSubmit,
          onCancel: _ctx.onExportDeclarationIssuedCancel
        }, null, 8, ["order-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_crossing_the_border)
      ? (_openBlock(), _createBlock(_component_ftl_cross_border, {
          key: 4,
          "order-id": _ctx.$route.params.order_id,
          onSubmit: _ctx.onCrossingTheBorderSubmit,
          onCancel: _ctx.onCrossingTheBorderCancel
        }, null, 8, ["order-id", "onSubmit", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_delivered)
      ? (_openBlock(), _createBlock(_component_enter_delivered_data, {
          key: 5,
          "is-loading": _ctx.state.is_delivered_loading,
          "additional-services": _ctx.state.ftlOrder?.additional_service,
          stocks: _ctx.getAdditionalServicesStock,
          "sender-city": _ctx.state.ftlOrder?.sender?.city,
          "ftl-type": _ctx.state.ftlOrder?.ftl_type,
          "status-code": _ctx.state.ftlOrder?.status_code,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          "state-id": _ctx.state.stateId,
          onSubmitted: _ctx.onDeliveredSubmit,
          onCancel: _ctx.onDelieveredCancel
        }, null, 8, ["is-loading", "additional-services", "stocks", "sender-city", "ftl-type", "status-code", "is-need-car", "state-id", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_completed)
      ? (_openBlock(), _createBlock(_component_enter_completed_data, {
          key: 6,
          "is-loading": _ctx.state.is_completed_loading,
          "additional-services": _ctx.state.ftlOrder?.additional_service,
          "sender-address": _ctx.state.ftlOrder?.sender?.full_address,
          stocks: _ctx.state.ftlOrder?.stock_delivery_notes,
          "status-code": _ctx.state.ftlOrder?.status_code,
          downtime: _ctx.state.ftlOrder?.downtime,
          "payment-rate-type-id": _ctx.state.ftlOrder?.downtime?.type,
          "is-need-car": _ctx.state.ftlOrder?.is_need_car,
          onSubmitted: _ctx.onCompletedSubmit,
          onCancel: _ctx.onCompletedCancel
        }, null, 8, ["is-loading", "additional-services", "sender-address", "stocks", "status-code", "downtime", "payment-rate-type-id", "is-need-car", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_scan_upload)
      ? (_openBlock(), _createBlock(_component_upload_ftl_order_scan, {
          key: 7,
          "ftl-order-id": _ctx.$route.params.order_id,
          "invoice-number": _ctx.state.ftlOrder.invoice_number,
          onSubmitted: _ctx.onScanUploadSubmit,
          onCancel: _ctx.onScanUploadCancel
        }, null, 8, ["ftl-order-id", "invoice-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.upload_vacation_invoice.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 8,
          class: "large",
          title: "Загрузка накладной на отпуск",
          "confirm-button-text": "Загрузить",
          loading: _ctx.upload_vacation_invoice.is_loading,
          onCancel: _ctx.onUploadVacationInvoiceCancel,
          onConfirm: _ctx.onUploadVacationInvoiceSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_file_reader, {
              placeholder: "Выберите файл",
              accept: "image/*",
              value: _ctx.upload_vacation_invoice.file,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.upload_vacation_invoice.file) = $event)),
              "is-invalid": _ctx.upload_vacation_invoice_form$.file.$error,
              "validation-errors": _ctx.upload_vacation_invoice_form$.file.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.upload_ftl_stock_scan.is_opened)
      ? (_openBlock(), _createBlock(_component_upload_ftl_stock_scan, {
          key: 9,
          "ftl-stock-id": _ctx.upload_ftl_stock_scan.ftl_stock_id,
          "direction-name": _ctx.upload_ftl_stock_scan.ftl_stock_directionName,
          "stock-number": _ctx.upload_ftl_stock_scan.ftl_stock_number,
          onSubmitted: _ctx.uploadStockScanSubmit,
          onCancel: _ctx.uploadStockScanCancel
        }, null, 8, ["ftl-stock-id", "direction-name", "stock-number", "onSubmitted", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.state.is_add_bid)
      ? (_openBlock(), _createBlock(_component_bids_form_ftl, {
          key: 10,
          order: _ctx.state.ftlOrder,
          onCancel: _ctx.toggleBidCreate,
          onAdded: _ctx.onBidCreated
        }, null, 8, ["order", "onCancel", "onAdded"]))
      : (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createBlock(_component_ftl_order_state, {
            key: 11,
            "is-loading": _ctx.state.is_loading,
            "is-failed": _ctx.state.is_failed,
            onRetry: _ctx.loadFtlOrder
          }, null, 8, ["is-loading", "is-failed", "onRetry"]))
        : (_ctx.state.ftlOrder)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
              _createVNode(_component_ftl_order_header, {
                "order-status": _ctx.state.ftlOrder.status,
                "order-status-code": _ctx.state.ftlOrder.status_code,
                "is-billing-enabled": _ctx.state.ftlOrder.billing_enabled,
                "is-international-transportation": _ctx.state.ftlOrder.ftl_type === 1,
                "ftl-bid-id": _ctx.state.ftlOrder.ftl_bid_id,
                "logist-bid-id": _ctx.state.ftlOrder.logist_bid_id,
                "logist-bid-status-id": _ctx.state.ftlOrder.logist_bid_status_id,
                "payment-by-suppliers-id": _ctx.state.ftlOrder.payment_by_suppliers_id,
                scan: _ctx.state.ftlOrder.scan,
                "is-status-loading": _ctx.state.is_status_loading,
                "is-transcript-printing": _ctx.state.is_transcript_printing,
                "is-route-printing": _ctx.state.is_route_printing,
                "is-resending-to-one-c": _ctx.state.is_resending_to_one_c,
                "is-invoices-printing": _ctx.state.is_invoices_printing,
                "already-have-one-c": _ctx.state.is_already_have_one_c,
                onAssignStatusOnTheWay: _ctx.assignStatusOnTheWayHandler,
                onAssignStatusExportDeclarationIssued: 
                    _ctx.assignStatusExportDeclarationIssuedHandler
                ,
                onAssignStatusCrossingTheBorder: _ctx.assignStatusCrossingTheBorderHandler,
                onAssignStatusDelivered: _ctx.assignStatusDeliveredHandler,
                onAssignStatusCompleted: _ctx.assignStatusCompletedHandler,
                onPrintTranscript: _ctx.onPrintTranscript,
                onPrintRoute: _ctx.onPrintRoute,
                onResendToOneC: _ctx.onResendToOneC,
                onAssignStatusCanceled: _ctx.assignStatusCanceled,
                onPrintInvoices: _ctx.onPrintInvoices,
                onDownloadScan: _ctx.onDownloadScan,
                onUploadScan: _ctx.onScanUploadHandler,
                onUploadVacationInvoice: _ctx.onUploadVacationInvoiceHandler,
                onOpenBidCreate: _ctx.toggleBidCreate
              }, null, 8, ["order-status", "order-status-code", "is-billing-enabled", "is-international-transportation", "ftl-bid-id", "logist-bid-id", "logist-bid-status-id", "payment-by-suppliers-id", "scan", "is-status-loading", "is-transcript-printing", "is-route-printing", "is-resending-to-one-c", "is-invoices-printing", "already-have-one-c", "onAssignStatusOnTheWay", "onAssignStatusExportDeclarationIssued", "onAssignStatusCrossingTheBorder", "onAssignStatusDelivered", "onAssignStatusCompleted", "onPrintTranscript", "onPrintRoute", "onResendToOneC", "onAssignStatusCanceled", "onPrintInvoices", "onDownloadScan", "onUploadScan", "onUploadVacationInvoice", "onOpenBidCreate"]),
              _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                (!_ctx.state.ftlDelayOutbound || _ctx.state.ftlDelayOutbound.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                  : (_openBlock(), _createBlock(_component_new_table, {
                      key: 1,
                      columns: _ctx.DELAY_INFO_COMMENTS_COLUMNS,
                      rows: _ctx.state.ftlDelayOutbound,
                      "fixed-cells": "",
                      "padding-bottom": "60"
                    }, {
                      td: _withCtx(({ column, row }) => [
                        (column.key === 'slaComment')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (row.slaComment)
                                ? (_openBlock(), _createBlock(_component_cheap, {
                                    key: 0,
                                    class: _normalizeClass(row.slaComment === 'Опоздание' ? 'red' : 'green')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cut(row.slaComment, 15)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, " - "))
                            ], 64))
                          : (column.key === 'expectedDate')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expectedDate)), 1)
                              ], 64))
                            : (column.key === 'date')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                                ], 64))
                              : (column.key === 'comment')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (row.comment)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.cut(
                                        row.slaComment === 'Сроки соблюдены'
                                            ? '[Не требуется]'
                                            : row.comment,
                                        15
                                    )), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " - "))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createTextVNode(_toDisplayString(_ctx.cut(row[column.key], 15) || '-'), 1)
                                  ], 64))
                      ]),
                      _: 1
                    }, 8, ["columns", "rows"])),
                (_ctx.isReasonOutbound)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_the_button, {
                        class: "primary small",
                        disabled: _ctx.state.is_set_comment_loading,
                        loading: _ctx.state.is_set_comment_loading,
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSetCommentNew('outbound')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Указать причину ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                (!_ctx.state.ftlDelayInbound || _ctx.state.ftlDelayInbound.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : (_openBlock(), _createBlock(_component_new_table, {
                      key: 1,
                      columns: _ctx.DELAY_INFO_COMMENTS_COLUMNS,
                      rows: _ctx.state.ftlDelayInbound,
                      "fixed-cells": "",
                      "padding-bottom": "60"
                    }, {
                      td: _withCtx(({ column, row }) => [
                        (column.key === 'slaComment')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (row.slaComment)
                                ? (_openBlock(), _createBlock(_component_cheap, {
                                    key: 0,
                                    class: _normalizeClass(row.slaComment === 'Опоздание' ? 'red' : 'green')
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.cut(row.slaComment, 15)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_16, " - "))
                            ], 64))
                          : (column.key === 'expectedDate')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expectedDate)), 1)
                              ], 64))
                            : (column.key === 'date')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                                ], 64))
                              : (column.key === 'comment')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (row.comment)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.cut(
                                        row.slaComment === 'Сроки соблюдены'
                                            ? '[Не требуется]'
                                            : row.comment,
                                        15
                                    )), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_18, " - "))
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                    _createTextVNode(_toDisplayString(_ctx.cut(row[column.key], 15) || '-'), 1)
                                  ], 64))
                      ]),
                      _: 1
                    }, 8, ["columns", "rows"])),
                (_ctx.isReasonInbound)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_the_button, {
                        class: "primary small",
                        disabled: _ctx.state.is_delivered_loading,
                        loading: _ctx.state.is_delivered_loading,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSetCommentNew('inbound')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Указать причину ")
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_ftl_order_tabs, {
                value: _ctx.state.currentTab,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.currentTab) = $event)),
                files: _ctx.ftlOrderFilesArray,
                "is-need-car": _ctx.state.ftlOrder?.is_need_car
              }, null, 8, ["value", "files", "is-need-car"]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.state.currentTab === 'general')
                    ? (_openBlock(), _createBlock(_component_ftl_order_general, {
                        key: 0,
                        "ftl-bid-id": _ctx.state.ftlOrder.ftl_bid_id,
                        "ftl-type-name": _ctx.state.ftlOrder.ftl_type_name,
                        "dop-order-number": _ctx.state.ftlOrder.dop_order_number,
                        "shipment-type-name": _ctx.state.ftlOrder.shipment_type_name,
                        "take-date": _ctx.state.ftlOrder.take_date,
                        "take-time": _ctx.state.ftlOrder.take_time,
                        "act-number": _ctx.state.ftlOrder.act_number,
                        "act-created-at": _ctx.state.ftlOrder.act_created_at,
                        "auto-duration-client": _ctx.state.ftlOrder.auto_duration_client,
                        "auto-count": _ctx.state.ftlOrder.auto_count,
                        manager: _ctx.state.ftlOrder.manager,
                        logist: _ctx.state.ftlOrder.logist,
                        "company-name": _ctx.state.ftlOrder.company_name,
                        annotation: _ctx.state.ftlOrder.annotation,
                        "created-at": _ctx.state.ftlOrder.created_at,
                        "received-by": _ctx.state.ftlOrder.received_by,
                        "delivery-date": _ctx.state.ftlOrder.delivery_date,
                        "auto-duration": _ctx.state.ftlOrder.auto_duration,
                        number: _ctx.state.ftlOrder.number,
                        "created-by": _ctx.state.ftlOrder.created_by,
                        "is-need-car": _ctx.state.ftlOrder?.is_need_car,
                        "logist-bid-id": _ctx.state.ftlOrder.logist_bid_id
                      }, null, 8, ["ftl-bid-id", "ftl-type-name", "dop-order-number", "shipment-type-name", "take-date", "take-time", "act-number", "act-created-at", "auto-duration-client", "auto-count", "manager", "logist", "company-name", "annotation", "created-at", "received-by", "delivery-date", "auto-duration", "number", "created-by", "is-need-car", "logist-bid-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'payment')
                    ? (_openBlock(), _createBlock(_component_ftl_order_payment, {
                        key: 1,
                        "ftl-order": _ctx.state.ftlOrder,
                        "sender-city": _ctx.senderCity,
                        "additional-service": _ctx.state.ftlOrder.shared_additional_service,
                        "payment-method": _ctx.state.ftlOrder.payment_method,
                        "declared-price": _ctx.state.ftlOrder.declared_price,
                        "payment-type": _ctx.state.ftlOrder.payment_type,
                        "is-prepayment": _ctx.state.ftlOrder.is_prepayment,
                        "cost-price-with-nds": _ctx.state.ftlOrder.cost_price_with_nds,
                        "ftl-type": _ctx.state.ftlOrder.ftl_type,
                        "payment-rate-type-id": _ctx.state.ftlOrder.payment_rate_type_id,
                        "company-name": _ctx.state.ftlOrder.company_name,
                        "cost-price-per-hour": _ctx.state.ftlOrder.cost_price_per_hour,
                        "cost-price": _ctx.state.ftlOrder.cost_price,
                        "cost-total": _ctx.state.ftlOrder.cost_total,
                        "paid-price-per-hour": _ctx.state.ftlOrder.paid_price_per_hour,
                        "paid-price": _ctx.state.ftlOrder.paid_price,
                        "paid-price-total": _ctx.state.ftlOrder.paid_price_total
                      }, null, 8, ["ftl-order", "sender-city", "additional-service", "payment-method", "declared-price", "payment-type", "is-prepayment", "cost-price-with-nds", "ftl-type", "payment-rate-type-id", "company-name", "cost-price-per-hour", "cost-price", "cost-total", "paid-price-per-hour", "paid-price", "paid-price-total"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'sender-and-stops')
                    ? (_openBlock(), _createBlock(_component_ftl_order_sender_and_stops, {
                        key: 2,
                        "additional-service": _ctx.state.ftlOrder.additional_service,
                        sender: _ctx.state.ftlOrder.sender,
                        "stock-delivery-notes": _ctx.state.ftlOrder.stock_delivery_notes,
                        "is-uploading-scan": false,
                        "is-printing-invoice": _ctx.state.is_printing_stock_invoice,
                        outbounds: _ctx.state.ftlDelayOutbound,
                        inbounds: _ctx.state.ftlDelayInbound,
                        onUploadScan: _ctx.uploadStockScanHandler,
                        onPrintInvoice: _ctx.printStockInvoiceHandler
                      }, null, 8, ["additional-service", "sender", "stock-delivery-notes", "is-printing-invoice", "outbounds", "inbounds", "onUploadScan", "onPrintInvoice"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'vehicle-information')
                    ? (_openBlock(), _createBlock(_component_ftl_order_vehicle, {
                        key: 3,
                        "carrier-name": _ctx.state.ftlOrder.carrier_name,
                        "car-brand": _ctx.state.ftlOrder.car_brand,
                        cubature: _ctx.state.ftlOrder.cubature,
                        "loading-type": _ctx.state.ftlOrder.loading_type,
                        "car-info": _ctx.state.ftlOrder.car_info,
                        "cargo-name": _ctx.state.ftlOrder.cargo_name,
                        "car-number": _ctx.state.ftlOrder.car_number,
                        "driver-name": _ctx.state.ftlOrder.driver_name,
                        "driver-phone": _ctx.state.ftlOrder.driver_phone,
                        "load-capacity": _ctx.state.ftlOrder.load_capacity,
                        "oversized-cargo": _ctx.state.ftlOrder.oversized_cargo,
                        "trailer-license-number": _ctx.state.ftlOrder.trailer_license_number,
                        "logist-bid-id": _ctx.state.ftlOrder.logist_bid_id
                      }, null, 8, ["carrier-name", "car-brand", "cubature", "loading-type", "car-info", "cargo-name", "car-number", "driver-name", "driver-phone", "load-capacity", "oversized-cargo", "trailer-license-number", "logist-bid-id"]))
                    : _createCommentVNode("", true),
                  (_ctx.state.currentTab === 'files')
                    ? (_openBlock(), _createBlock(_component_ftl_order_files, {
                        key: 4,
                        files: _ctx.ftlOrderFilesArray
                      }, null, 8, ["files"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_ftl_order_statuses, {
                    statuses: _ctx.state.ftlOrder.order_statuses
                  }, null, 8, ["statuses"])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
  ]))
}